<div class="upper">
  <div class="headline">
    {{ 'home.menu.title' | translate }}
  </div>
  <ul class="menu">
    <li class="menu-entry">
      <a routerLink="/home/paycards" routerLinkActive="active">
        {{ 'home.paycards.overview.title' | translate }}
      </a>
    </li>
    <li class="menu-entry">
      <a routerLink="/home/webcharges" routerLinkActive="active">
        {{ 'home.webcharges.overview.title' | translate }}
      </a>
    </li>
    <li class="menu-entry">
      <a routerLink="/home/preorders" routerLinkActive="active">
        {{ 'home.preorders.overview.title' | translate }}
      </a>
    </li>
    <li class="menu-entry">
      <a routerLink="/home/users" routerLinkActive="active">
        {{ 'home.users.overview.title' | translate }}
      </a>
    </li>
  </ul>
</div>
<div class="lower">
</div>
